import baseStore from '@/stores/Store.js'
import authorizationStore from '@/stores/authorization-store.js'
import toastStore from '@/stores/toast-store.js'
import sessionStore from '@/stores/session-store.js'
import axios from 'axios'
import CurrentUserResolver from '@/mixins/current-user-resolver.js'
import jquery from 'jquery'

const DEFAULT_TRANSITION = 'slide-left'

const beMoreVerbose = false

export default {
  mixins: [CurrentUserResolver],
  data: function () {
    return {
      transitionName: DEFAULT_TRANSITION,
      basePaths: ['lockers', 'delivery', 'profile'],
      userFetchingUnsubscription: null,
    }
  },
  methods: {
    setCurrentAnimation(from, to) {
      if (!from || !to) {
        baseStore.commit('setCurrentAnimation', 'slide-left')
        return
      }

      let fromBase = from.path.match(/\/([\w-]+)\/.*/i)
      if (fromBase && fromBase.length) {
        fromBase = fromBase[1]
      } else {
        fromBase = ''
      }

      let toBase = to.path.match(/\/([\w-]+)\/.*/i)
      if (toBase && toBase.length) {
        toBase = toBase[1]
      } else {
        toBase = ''
      }

      if (fromBase != toBase) {
        if (this.basePaths.indexOf(fromBase) > this.basePaths.indexOf(toBase)) {
          baseStore.commit('setCurrentAnimation', 'slide-right')
        } else {
          baseStore.commit('setCurrentAnimation', 'slide-left')
        }
      } else {
        // lukas's additional if
        if (!fromBase.length && !toBase.length) {
          const toNavPath = to.matched[0] ? to.matched[0].path.replace(/\//g, '') : ''
          const fromNavPath = from.matched[0] ? from.matched[0].path.replace(/\//g, '') : ''

          if (this.basePaths.indexOf(fromNavPath) > this.basePaths.indexOf(toNavPath)) {
            baseStore.commit('setCurrentAnimation', 'slide-right')
          } else {
            baseStore.commit('setCurrentAnimation', 'slide-left')
          }
        } else {
          if (from.matched.length > to.matched.length) {
            baseStore.commit('setCurrentAnimation', 'slide-right')
          } else {
            baseStore.commit('setCurrentAnimation', 'slide-left')
          }
        }
      }
    },
    setApplebarStyle(route) {
      if (route.meta && route.meta.auth) {
        jquery('meta[name="apple-mobile-web-app-status-bar-style"]').each(function () {
          jquery(this).attr('content', 'black-translucent')
        })
      } else {
        jquery('meta[name="apple-mobile-web-app-status-bar-style"]').each(function () {
          jquery(this).attr('content', 'default')
        })
      }
    },
    memoLastRoute(route) {
      baseStore.commit('memoLastPage', route)
    },
    removeLastRoute(route) {
      baseStore.commit('removeLastPage', route)
    },
    signOutAndGo(from, to, next) {
      axios({
        method: 'delete',
        url: 'auth/sign_out',
      })
        .then(response => {
          sessionStore.commit('setData', null)
          toastStore.commit('warning', {
            message: this.$t('messages.routerHooks.signedOut'),
          })
          this.setCurrentAnimation(from, to)
          this.memoLastRoute(to)
          this.setApplebarStyle(to)
          console.log(
            '%c AUTHORIZATION CHECK: success (with logging out)',
            'color: green; font-weight: bold;',
          )
          if (next) {
            next()
          }
        })
        .catch(error => {
          console.log(
            "%c AUTHORIZATION CHECK: failed - can't sign out the user",
            'color: orange; font-weight: bold;',
          )
          console.error('error signOut', error)
          toastStore.commit('error', {
            message: this.$t('messages.routerHooks.signedOutFailure'),
          })
          if (next) {
            if (from && (from.matched || []).length) {
              next(false)
            } else {
              next('/')
            }
          } else {
            this.removeLastRoute(to)
            this.$router.push('/')
          }
        })
    },
    routeChangeHandler(to, from, next) {
      if (this.userFetchingUnsubscription) {
        this.userFetchingUnsubscription()
        this.userFetchingUnsubscription = null
      }
      // WAIT FOR CURRENT USER
      if (sessionStore.getters.currentlyFetching == true && to.path != '/okta-setup') {
        if (beMoreVerbose)
          console.log(
            '%c AUTHORIZATION CHECK: waiting for current user',
            'color: #ccc; font-weight: bold;',
          )
        this.userFetchingUnsubscription = sessionStore.subscribe((mutation, state) => {
          if (['currentlyFetching', 'setUser'].indexOf(mutation.type) != -1) {
            this.routeChangeHandler(to, from, next)
          }
        })
        return
      }
      if (beMoreVerbose)
        console.log(
          '%c AUTHORIZATION CHECK: will try to check',
          'color: #ccc; font-weight: bold;',
          to.path,
        )

      // initial app run has no matched for routes
      if (to.matched && to.matched.length) {
        const auth = _.last(_.compact(_.map(to.matched, el => (el.meta || {}).auth)))
        // is opened or needs logging out
        if (auth) {
          if (beMoreVerbose)
            console.log(
              '%c AUTHORIZATION CHECK: there is meta',
              'color: #ccc; font-weight: bold;',
              auth,
            )
          // needs logging out
          if (auth == 'logoutAndGo' && sessionStore.getters.user) {
            if (beMoreVerbose)
              console.log(
                '%c AUTHORIZATION CHECK: will log out a user',
                'color: #ccc; font-weight: bold;',
              )
            this.signOutAndGo(from, to, next)
            return
          }

          // needs authentication and authorization
        } else if (!sessionStore.getters.user || !authorizationStore.getters.can(to.path)) {
          if (!sessionStore.getters.user) {
            console.log(
              '%c AUTHORIZATION CHECK: failed - there is no logged user required by the page',
              'color: orange; font-weight: bold;',
            )
            // airbrake.notify({
            //   error: new Error('there is no logged user'),
            //   context: { component: 'PWA' },
            // })
          } else {
            console.log(
              '%c AUTHORIZATION CHECK: failed - the user has no privileges to see the page with roles: ',
              'color: orange; font-weight: bold;',
              [...sessionStore.getters.user.roles],
            )
            // airbrake.notify({
            //   error: new Error('the user has no privileges to see the page with roles:'),
            //   context: { component: 'PWA' },
            //   params: { roles: sessionStore.getters.user.roles },
            // })
          }
          toastStore.commit('error', {
            message: this.$t('messages.routerHooks.noAuthorization'),
          })
          if (next) {
            if (from && (from.matched || []).length) {
              next(false)
            } else {
              next('/')
            }
          } else {
            this.removeLastRoute(to)
            this.$router.push('/')
          }
          return
        }

        console.log('%c AUTHORIZATION CHECK: success', 'color: green; font-weight: bold;')
        this.setCurrentAnimation(from, to)
        this.memoLastRoute(to)
        this.setApplebarStyle(to)
      } else {
        console.log(
          '%c AUTHORIZATION CHECK: failed - route has no matched items',
          'color: orange; font-weight: bold;',
          to,
        )
        if (next) {
          next('/')
        } else {
          this.removeLastRoute(to)
          this.$router.push('/')
        }
      }
      if (next) {
        next()
      }
    },
  },
  watch: {
    'currentUser.roles': {
      handler(newVal, oldVal) {
        // there is a role taken from the user
        if (_.intersection(oldVal || [], newVal || []).length != (oldVal || []).length) {
          this.routeChangeHandler(this.$router.currentRoute, null, null)
        }
      },
    },
  },
  created() {
    this.fetchUser()
    this.$router.beforeResolve(this.routeChangeHandler)
    // setTimeout(() =>
    //   this.routeChangeHandler(this.$route, null, null)
    // )
  },
}
